module.exports = __webpack_public_path__ + "img/video.e9bf3fd3.svg";